
import {PropType, defineComponent} from 'vue';
import {defaultPagination} from '~/utils/graphql';

export default defineComponent({
  props: {
    pagination: {
      default: defaultPagination(),
      type: Object as PropType<{
        current_page: number
        total: number
        per_page: number
      }>,
    },
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3,
    },
    value: {
      type: Number as PropType<number>,
      required: true,
    },
  },

  computed: {
    totalPages() {
      return this.pagination.total < this.pagination.per_page ? 1 : Math.ceil(this.pagination.total / this.pagination.per_page);
    },
    startPage() {
      if (this.value === 1) {
        return 1;
      }

      if (this.value === this.totalPages) {
        return Math.max(1, this.totalPages - this.maxVisibleButtons + 1);
      }

      return Math.max(1, this.value - Math.floor(this.maxVisibleButtons / 2));
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages() {
      const range = [];

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.value,
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.value === 1;
    },
    isInLastPage() {
      return this.value === this.totalPages;
    },
  },
  methods: {
    scrollUp() {
      window.scrollTo(0, 0);
    },
    onClickFirstPage() {
      this.$emit('input', 1);
    },
    onClickPreviousPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    },
    onClickPage(page: number) {
      if (page > 0) {
        this.$emit('input', page);
      }
    },
    onClickNextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    onClickLastPage() {
      this.$emit('input', this.totalPages);
    },
    isPageActive(page: number) {
      return this.value === page;
    },
  },
});
